module.exports = __webpack_public_path__ + "media/workplace/trash-icon-e6795f33.svg";